import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { login } from "../../../../redux/features/authSlice";
import { Button, TextInput } from "../../../../components";

const SchoolLoginForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [schoolEmail, setSchoolEmail] = useState("");
  const [schoolPassword, setSchoolPassword] = useState("");
  const [schoolLoginError, setSchoolLoginError] = useState("");
  const [schoolLoginLoading, setSchoolLoginLoading] = useState(false);

  const handleSchoolLoginSubmit = async (e) => {
    e.preventDefault();
    setSchoolLoginError("");

    if (!schoolEmail.trim()) {
      setSchoolLoginError("Please enter your school email.");
      return;
    }
    if (!schoolPassword) {
      setSchoolLoginError("Please enter your password.");
      return;
    }

    setSchoolLoginLoading(true);
    try {
      await dispatch(login({ email: schoolEmail.trim(), password: schoolPassword })).unwrap();
      navigate("/schoolDashboard");
    } catch (err) {
      setSchoolLoginError(err || "Login failed. Please check your credentials.");
    } finally {
      setSchoolLoginLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto my-8 bg-white border border-gray-100 rounded-[2rem] p-6 sm:p-8 shadow-[0_8px_30px_rgb(0,0,0,0.04)]">
      <form onSubmit={handleSchoolLoginSubmit} className="w-full flex flex-col justify-start" noValidate>
        <button
          type="button"
          onClick={() => navigate("/login")}
          className="inline-flex items-center gap-1.5 text-xs sm:text-sm font-bold text-gray-800 hover:text-black mb-3 transition-colors w-fit focus:outline-none cursor-pointer"
        >
          <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" />
          </svg>
          <span>Back to Individual Login</span>
        </button>

        <h3 className="text-xl sm:text-2xl font-extrabold text-[#111827] tracking-tight leading-tight mb-0.5">
          School Sign In
        </h3>
        <p className="text-xs text-gray-500 font-medium mb-4">
          Enter your registered school credentials to manage batches
        </p>

        <div className="form-group flex flex-col mb-3">
          <label htmlFor="schoolEmail" className="text-xs sm:text-sm font-bold text-gray-700 mb-1">
            School Email <span className="text-[#E5383B]">*</span>
          </label>
          <TextInput
            type="email"
            placeholderText="principal@school.edu"
            inputName="schoolEmail"
            inputValue={schoolEmail}
            isRequired={true}
            inputClassName="!h-[44px] !rounded-xl !bg-white !border-gray-200 focus:!border-[#6366F1] !text-sm"
            handleChange={(e) => setSchoolEmail(e.target.value)}
          />
        </div>

        <div className="form-group flex flex-col mb-3">
          <label htmlFor="schoolPassword" className="text-xs sm:text-sm font-bold text-gray-700 mb-1">
            Password <span className="text-[#E5383B]">*</span>
          </label>
          <TextInput
            type="password"
            placeholderText="••••••••"
            inputName="schoolPassword"
            inputValue={schoolPassword}
            isRequired={true}
            inputClassName="!h-[44px] !rounded-xl !bg-white !border-gray-200 focus:!border-[#6366F1] !text-sm"
            handleChange={(e) => setSchoolPassword(e.target.value)}
          />
        </div>

        {schoolLoginError && (
          <div className="text-[#E5383B] text-xs font-semibold mb-2.5">{schoolLoginError}</div>
        )}

        <div className="w-full mt-2">
          <Button
            version="secondary"
            text="Sign In as School"
            type="submit"
            loading={schoolLoginLoading}
            width="100%"
            className="w-full justify-center font-extrabold"
          />
        </div>

        <div className="text-center mt-4">
          <p className="text-xs text-gray-500 font-medium">
            New School?{" "}
            <Link to="/register/school" className="text-[#009DFF] hover:underline font-bold">
              Register here
            </Link>
          </p>
        </div>
      </form>
    </div>
  );
};

export default SchoolLoginForm;
